interface RouteHeroProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}

const FILTERS = [
  { id: "all", label: "Tümü", icon: "ri-layout-grid-line" },
  { id: "easy", label: "Kolay", icon: "ri-walk-line" },
  { id: "medium", label: "Orta", icon: "ri-riding-line" },
  { id: "Genel", label: "Genel", icon: "ri-compass-3-line" },
  { id: "Tarih", label: "Tarih", icon: "ri-ancient-pavilion-line" },
  { id: "Lezzet", label: "Lezzet", icon: "ri-restaurant-line" },
  { id: "Aile", label: "Aile", icon: "ri-user-heart-line" },
  { id: "Hafta Sonu", label: "Hafta Sonu", icon: "ri-calendar-2-line" },
];

export default function RouteHero({ activeFilter, onFilterChange }: RouteHeroProps) {
  return (
    <section className="relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bf429ed6c51383613e64cca281708665.jpg"
          alt="Bursa Rotaları"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-stone-900/70 via-stone-900/60 to-stone-900/90" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 pt-28 pb-16">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-sm text-white/50 mb-6">
          <a href="/" className="hover:text-white/80 transition-colors cursor-pointer">Ana Sayfa</a>
          <i className="ri-arrow-right-s-line" />
          <span className="text-white/80">Rotalar</span>
        </div>

        {/* Title */}
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-700/40 text-emerald-300 text-xs font-semibold uppercase tracking-wider mb-5">
            <i className="ri-map-2-line" /> Hazır Rotalar
          </span>
          <h1 className="font-playfair text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
            Bursa'yı Planlı <br /><span className="text-emerald-400">Keşfedin</span>
          </h1>
          <p className="text-white/60 text-base leading-relaxed max-w-xl">
            Uzmanlarımızın hazırladığı 5 farklı rota. İlgi alanınıza ve sürenize göre seçin, adım adım takip edin.
          </p>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap items-center gap-6 mt-8">
          {[
            { icon: "ri-route-line", label: "5 Hazır Rota" },
            { icon: "ri-time-line", label: "6 – 18 Saat" },
            { icon: "ri-map-pin-line", label: "40+ Durak" },
            { icon: "ri-star-line", label: "Uzman Seçimi" },
          ].map((s) => (
            <div key={s.label} className="flex items-center gap-2 text-white/70 text-sm">
              <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-white/10">
                <i className={`${s.icon} text-sm text-emerald-400`} />
              </span>
              <span>{s.label}</span>
            </div>
          ))}
        </div>

        {/* Filter tabs */}
        <div className="flex flex-wrap gap-2 mt-10">
          {FILTERS.map((f) => (
            <button
              key={f.id}
              onClick={() => onFilterChange(f.id)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeFilter === f.id
                  ? "bg-emerald-600 text-white"
                  : "bg-white/10 text-white/70 hover:bg-white/20 hover:text-white"
              }`}
            >
              <i className={`${f.icon} text-sm`} />
              {f.label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
